import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { jwtDecode } from 'jwt-decode';
import axios from 'utils/axiosConfig';
import { Logo } from 'assets/landing';
import Styles from './adminLayout.module.scss';

export const AdminLayout = ({
	children,
	password = '1234',
}) => {
	const [inputPassword, setInputPassword] = useState('');
	const [isUnlocked, setIsUnlocked] = useState(false);
	const [loading, setLoading] = useState(true);

	const handleSubmit = () => {
		if (!inputPassword || inputPassword !== password) {
			toast.error('Invalid Password');
			return;
		}

		setIsUnlocked(true);
	};

	const fetchUser = async () => {
		setLoading(true);

		const accessToken = localStorage.getItem('accessToken');

		if (accessToken) {
			const decoded = jwtDecode(accessToken);

			const isExpired = !decoded.exp || decoded.exp * 1000 < Date.now();

			if (!isExpired) {
				setIsUnlocked(true);
				setLoading(false);

				return;
			}
		}

		try {
			const res = await axios.get('/employees/login', {
				headers: {
					pin: '1207',
				}
			});

			if (res.data) {
				localStorage.setItem('accessToken', res.data.access_token);
				localStorage.setItem('employeeID', res.data.employee.id);
			}
		} catch (e) {
			console.log(e);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchUser();
	}, []);

	if (loading) {
		return <div>Loading</div>;
	}

	if (!isUnlocked) {
		return (
			<div className={`${Styles.container} gap-5`}>
				<img width={200} src={Logo} alt='' />
				<h2 className='mt-1'>Enter password to continue</h2>

				<input
					className={Styles.input}
					type='password'
					value={inputPassword}
					onChange={(e) => setInputPassword(e.target.value)}
				/>

				<button
					disabled={!inputPassword.length}
					onClick={handleSubmit}
					className={Styles.submitButton}
				>
					Continue
				</button>
			</div>
		);
	}

	return <>{children}</>;
};
